import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Provider } from "risa-data-model";
import { FirestoreService } from "../../api/firebase/firestoreService";
import { FirestoreCollectionReference } from "../../api/firebase/references";
import { AppDispatch, DataState } from "../store/store";

// Extended Provider type with required id field
export type FacilityProvider = Provider & {
  id: string;
  name?: string;
  email?: string;
  role_id?: string;
  is_active?: boolean;
  created_at?: string;
  invited_by?: string;
};

const initialState: DataState<FacilityProvider[]> = {
  data: null,
  loading: false,
  error: null,
};

const providerSlice = createSlice({
  name: "provider",
  initialState,
  reducers: {
    getProvidersStart(state) {
      state.loading = true;
      state.error = null;
    },
    getProvidersSuccess(state, action: PayloadAction<FacilityProvider[]>) {
      state.data = action.payload;
      state.loading = false;
    },
    getProvidersFailure(state, action: PayloadAction<string>) {
      state.error = action.payload;
      state.loading = false;
    },
    resetProviders(state) {
      state.data = null;
      state.loading = false;
      state.error = null;
    },
  },
});

export const {
  getProvidersStart,
  getProvidersSuccess,
  getProvidersFailure,
  resetProviders,
} = providerSlice.actions;

export const getAllProviderDetailsForClinic =
  (facilityId: string) => async (dispatch: AppDispatch) => {
    dispatch(getProvidersStart());
    const unsubscribe = FirestoreService.listenToAllDocuments<FacilityProvider>(
      FirestoreCollectionReference.healthFacilityProviders(facilityId),
      (providersData) => {
        dispatch(getProvidersSuccess(providersData));
      },
      (error) => {
        dispatch(getProvidersFailure(error.message));
      },
    );

    return unsubscribe;
  };

export default providerSlice.reducer;
